import { components } from "@certn/legacy-api/generated-schemas/people";

import { EducationInputField } from "./EducationInputField";
import { EducationSummaryField } from "./EducationSummaryField";
import { FieldType } from "../types";

export function EducationField(
  field: components["schemas"]["EducationCheckField"]
): FieldType<components["schemas"]["EducationCheckField"]> {
  return {
    field,
    inputElement: <EducationInputField key={field.name} field={field} />,
    summaryElement: () => (
      <EducationSummaryField key={field.name} field={field} />
    ),
    initialValue: field.value,
  };
}
